function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { HiddenField } from '@guryou/html-components';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { format, parse } from 'date-fns';
import PropTypes from 'prop-types';
const TIME_FORMAT = 'HH:mm';
const TimePickers = ({
  fieldName,
  value,
  label,
  onChange,
  ...rest
}) => {
  const [defaultValue, setDefaultValue] = useState(value ? parse(value, TIME_FORMAT, new Date()) : null);
  const onChangeHandler = date => {
    setDefaultValue(date);
    onChange && onChange(date);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiddenField, {
    name: fieldName,
    value: defaultValue ? format(defaultValue, TIME_FORMAT) : ''
  }), /*#__PURE__*/React.createElement(KeyboardTimePicker, _extends({
    inputVariant: "outlined",
    margin: "normal"
  }, rest, {
    InputProps: {
      name: null
    },
    autoOk: true,
    label: label,
    ampm: false,
    value: defaultValue,
    minutesStep: 5,
    onChange: onChangeHandler
  })));
};
TimePickers.propTypes = {
  disablePast: PropTypes.bool,
  format: PropTypes.string,
  fieldName: PropTypes.string
};
TimePickers.defaultProps = {
  disablePast: true
};
export default TimePickers;